// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"b268f3e8f76d7f21f213","293":"3d0a63ad3f8e6a88385b","518":"85ec1bde7e6e37e102fd","779":"fc0b734a2e103cb05230"}[chunkId] + ".js";
};